import React, { Component } from "react";
import {
  Grid,
  NavBar,
  WingBlank,
  WhiteSpace,
  ActionSheet,
  Toast,
  Card,
  Icon,
  Flex
} from "antd-mobile";
import { connect } from "dva";
import http from '../../utils/request'
import { clearAuthStorage } from '../../utils/auth-storage'
import "./menu.scss";
import menu_user_list from "../../assets/images/icon/menu_user_list.png";
import menu_add_user from "../../assets/images/icon/menu_user_add.png";
import menu_saoyisao from '../../assets/images/icon/saoyisao.png'
import menu_group_list from "../../assets/images/icon/menu_group_list.png";
import menu_group_add from "../../assets/images/icon/menu_group_add.png";
import menu_group_combination from "../../assets/images/icon/menu_group_combination.png";
import menu_bill_record from "../../assets/images/icon/menu_bill_record.png";
import admin_list from "../../assets/images/icon/admin_list.png";
import admin_add from "../../assets/images/icon/admin_add.png";
import menu_sim_info from "../../assets/images/icon/menu_sim_info.png";
import site_icon from "../../assets/images/icon/site_icon.png";

function getLoginUserMsg() {
  const loginMsg = sessionStorage.getItem("loginMsg");
  return loginMsg ? JSON.parse(loginMsg) : {};
}

const ALL_USER_MENU = [
  { icon: menu_user_list, text: "用户列表", type: "1-1" },
  { icon: menu_add_user, text: "用户添加", type: "1-2" },
  { icon: menu_saoyisao, text: "IMEI扫码", type: "1-3" },
  { icon: menu_bill_record, text: "ICCID放号", type: "1-5" },
  { icon: site_icon, text: "定位", type: "1-6" },
];

const ALL_GROUP_MENU = [
  { icon: menu_group_list, text: "群组列表", type: "2-1" },
  { icon: menu_group_add, text: "群组添加", type: "2-2" },
  { icon: menu_group_combination, text: "嵌套群组", type: "2-3" },
];

const adminData = [
  { icon: admin_list, text: "管理员列表", type: "4-1" },
  { icon: admin_add, text: "添加管理员", type: "4-2" },
];

const simData = [
  { icon: menu_sim_info, text: "卡号信息查询", type: "5-1" },
];

const cardPoolData = [
  { icon: menu_sim_info, text: "卡号信息查询", type: "5-1" },
  { icon: menu_sim_info, text: "卡池信息查询", type: "6-1" },
];

/** 总/高/一级管理员：用户模块仅「用户列表」 */
function getUserMenu(userType) {
  if (userType >= 1 && userType <= 3) {
    return ALL_USER_MENU.filter(item => item.type === "1-1");
  }
  return ALL_USER_MENU;
}

/** 二级管理员：完整群组菜单；系统管理员及总/高/一级：无群组 */
function getGroupMenu(userType) {
  if (userType === 4) {
    return ALL_GROUP_MENU;
  }
  return [];
}

export class Menu extends Component {
  state = {
    adminCurrencyAll: {
      currency1: { surplusCount: 0, totalCount: 0, usedCount: 0 },
      currency2: { surplusCount: 0, totalCount: 0, usedCount: 0 },
      currency3: { surplusCount: 0, totalCount: 0, usedCount: 0 },
      currency5: { surplusCount: 0, totalCount: 0, usedCount: 0 },
      currency11: { surplusCount: 0, totalCount: 0, usedCount: 0 },
      currency12: { surplusCount: 0, totalCount: 0, usedCount: 0 },
      currency32: { surplusCount: 0, totalCount: 0, usedCount: 0 },
    }
  };

  componentDidMount() {
    this.props.deleteSelectUserList();
    this.props.emptySelectGroup();
    this.getAdminCurrency();
    sessionStorage.removeItem("userListPage");
  }

  getAdminCurrency() {
    const userMsg = getLoginUserMsg();
    if (!userMsg.id) return;
    http.get('/api/currency/countOfAdminAll', { id: userMsg.id }, 'new').then(res => {
      if (res.status == 200) {
        this.setState({ adminCurrencyAll: res.data });
      }
    });
  }

  handleMenuClick(e) {
    let url = "";
    switch (e.type) {
      case "1-1":
        url = "/newUserList";
        break;
      case "1-2":
        url = "/newAddUser";
        break;
      case "1-3":
        url = "/clockinsdk";
        break;
      case "1-5":
        url = "/newBindingIccid";
        break;
      case "1-6":
        url = "/newLocationMsg";
        break;
      case "2-1":
        url = "/newGrouplist";
        break;
      case "2-2":
        url = "/newAddgroup";
        break;
      case "2-3":
        url = "/newGroupcombination";
        break;
      case "4-1":
        url = "/newAdminList";
        break;
      case "4-2":
        url = "/newAddadmin";
        break;
      case "5-1":
        url = "/simInfo";
        break;
      case "6-1":
        url = "/simFlowPool";
        break;
      default:
        break;
    }
    if (url) {
      this.props.history.push({ pathname: url });
    }
  }

  finishLogout = () => {
    clearAuthStorage();
    Toast.success("注销成功", 1, () => {
      window.location.href = "/login";
    });
  };

  loginOut = () => {
    ActionSheet.showActionSheetWithOptions(
      {
        options: ["确定", "取消"],
        cancelButtonIndex: 1,
        destructiveButtonIndex: 0,
        message: "是否注销登录？",
        maskClosable: true
      },
      buttonIndex => {
        if (buttonIndex == 0) {
          Toast.loading("退出登录中...", 1);
          setTimeout(() => {
            http.get('/auth/logout', {}, 'new').then(res => {
              if (res && res.status == 200) {
                this.finishLogout();
              } else {
                Toast.info((res && res.message) || '注销失败', 2);
              }
            }).catch(() => {
              this.finishLogout();
            });
          }, 1000);
        }
      }
    );
  };

  adminLevelName(userType) {
    if (userType == 0) return "系统管理员";
    if (userType == 1) return "总管理员";
    if (userType == 2) return "高级管理员";
    if (userType == 3) return "一级管理员";
    if (userType == 4) return "二级管理员";
    return "";
  }

  render() {
    const userMsg = getLoginUserMsg();
    const userType = Number(userMsg.userType);
    const userMenu = getUserMenu(userType);
    const groupMenu = getGroupMenu(userType);
    const { currency1, currency2, currency3, currency5, currency11, currency12, currency32 } = this.state.adminCurrencyAll;

    return (
      <div className="menu" style={{ paddingBottom: 50 }}>
        <div className="header-sticky">
          <NavBar mode="dark">铁通集团对讲管理平台</NavBar>
        </div>
        <div className="sub-container">
          <WingBlank>
            <div>
              <WhiteSpace size="lg" />
              <Card>
                <Card.Header
                  title={userMsg.loginName}
                  thumb={admin_list}
                  extra={
                    <div>
                      <div
                        onClick={() =>
                          this.props.history.push(`/newAddadmin/${userMsg.loginName}/edit/${userMsg.id}`)
                        }
                      >
                        <Icon type="right" />
                      </div>
                      <div>{this.adminLevelName(userType)}</div>
                    </div>
                  }
                />
                <Card.Body>
                  <div>
                    <Flex style={{ color: '#a7abb7' }}>
                      <Flex.Item style={{ fontSize: '9px' }}>一年虚拟币: {currency11.totalCount}/{currency11.surplusCount}/{currency11.usedCount}</Flex.Item>
                      <Flex.Item style={{ fontSize: '9px' }}>三年虚拟币: {currency1.totalCount}/{currency1.surplusCount}/{currency1.usedCount}</Flex.Item>
                    </Flex>
                    <WhiteSpace size="lg" />
                    <Flex style={{ color: '#a7abb7' }}>
                      <Flex.Item style={{ fontSize: '9px' }}>一年续费币: {currency12.totalCount}/{currency12.surplusCount}/{currency12.usedCount}</Flex.Item>
                      <Flex.Item style={{ fontSize: '9px' }}>三年续费币: {currency32.totalCount}/{currency32.surplusCount}/{currency32.usedCount}</Flex.Item>
                    </Flex>
                    <WhiteSpace size="lg" />
                    <Flex style={{ color: '#a7abb7' }}>
                      <Flex.Item style={{ fontSize: '9px' }}>优惠账号续费币: {currency2.totalCount}/{currency2.surplusCount}/{currency2.usedCount}</Flex.Item>
                      <Flex.Item style={{ fontSize: '9px' }}>vip续费币: {currency5.totalCount}/{currency5.surplusCount}/{currency5.usedCount}</Flex.Item>
                    </Flex>
                    <WhiteSpace size="lg" />
                    <Flex style={{ color: '#a7abb7' }}>
                      <Flex.Item style={{ fontSize: '9px' }}>行业币: {currency3.totalCount}/{currency3.surplusCount}/{currency3.usedCount}</Flex.Item>
                      <Flex.Item style={{ fontSize: '9px', color: 'red' }}>备注: 总数 / 可用 / 已用</Flex.Item>
                    </Flex>
                    <WhiteSpace size="lg" />
                  </div>
                </Card.Body>
                <Card.Footer
                  extra={
                    <span size="small" onClick={() => this.loginOut()}>
                      安全退出
                    </span>
                  }
                />
              </Card>
            </div>

            <div className="list-item">
              <div className="title">用户管理</div>
              <Grid
                data={userMenu}
                columnNum={userMenu.length}
                square={false}
                onClick={e => this.handleMenuClick(e)}
              />
            </div>

            {groupMenu.length > 0 ? (
              <div className="list-item">
                <div className="title">群组管理</div>
                <Grid
                  data={groupMenu}
                  columnNum={groupMenu.length}
                  square={false}
                  onClick={e => this.handleMenuClick(e)}
                />
              </div>
            ) : null}

            {userType === 4 ? (
              <div className="list-item">
                <div className="title">卡号管理</div>
                <Grid
                  data={simData}
                  columnNum={simData.length}
                  square={false}
                  onClick={e => this.handleMenuClick(e)}
                />
              </div>
            ) : null}

            {userType === 0 ? (
              <div className="list-item">
                <div className="title">SIM卡管理</div>
                <Grid
                  data={cardPoolData}
                  columnNum={cardPoolData.length}
                  square={false}
                  onClick={e => this.handleMenuClick(e)}
                />
              </div>
            ) : null}

            {userType < 4 ? (
              <div className="list-item">
                <div className="title">管理员管理</div>
                <Grid
                  data={adminData}
                  columnNum={adminData.length}
                  square={false}
                  onClick={e => this.handleMenuClick(e)}
                />
              </div>
            ) : null}

            <WhiteSpace size="xl" />
          </WingBlank>
          <WhiteSpace size="lg" />
          <WhiteSpace size="lg" />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  prop: state.prop
});

const mapDispatchToProps = dispatch => ({
  emptySelectGroup: () => {
    dispatch({ type: "group/emptyGroups" });
  },
  deleteSelectUserList: () => {
    dispatch({ type: "userSelectList/deleteSelectUserList" });
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(Menu);
